import type { AuthTokens, TokenStorage } from "../types/auth.types";

export const createLocalStorageTokenStorage = (key = "ecommerce_auth_tokens"): TokenStorage => ({
  save: (tokens: AuthTokens) => {
    localStorage.setItem(key, JSON.stringify(tokens));
  },
  get: () => {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      return JSON.parse(raw) as AuthTokens;
    } catch {
      localStorage.removeItem(key);
      return null;
    }
  },
  clear: () => {
    localStorage.removeItem(key);
  },
});
